import Vue from 'vue'
import VueRouter from 'vue-router'

// const Answer = r => require.ensure([], () => r(require('../page/Answer'), 'answer'))
const AnswerNew = r => require.ensure([], () => r(require('../page/AnswerNew'), 'answerNew'))
const AnswerEnd = r => require.ensure([], () => r(require('../page/AnswerEnd'), 'answerend'))
const AnswerTips = r => require.ensure([], () => r(require('../page/AnswerTips'), 'answertips'))
const EmailRefuseTips = r => require.ensure([], () => r(require('../page/EmailRefuseTips'), 'emailRefuseTips'))

const routes = [{
  path: '/',
  redirect: '/answer'
}, {
  path: '/answer',
  meta: { auth: false, nocache: true },
  component: AnswerNew
},
{
  path: '/answerend',
  meta: { auth: false, nocache: true },
  component: AnswerEnd
}, {
  path: '/answerTips',
  meta: { auth: false, nocache: true },
  component: AnswerTips
}, {
  path: '/emailRefuseTips',
  meta: { auth: false, nocache: true },
  component: EmailRefuseTips
}]

Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: 'hash',
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js